import React from 'react';
import {
  Hero,
  Goals,
  About,
  // Advert,
  Footer,
  Products,
  Contact,
} from './sections';

const App = () => {
  return (
    <div style={{ overflowX: 'hidden' }}>
      <Hero />
      <Goals />
      <About />
      <Products />
      {/* <Advert /> */}
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
